import React, { useContext } from "react";
import { Modal, Box, Typography, Button, Stack } from "@mui/material";
import { useReassingModal } from "./styles";
import { Info } from "@mui/icons-material";
import { ConfirmModal } from "../ConfirmModal";
import { Item, onChangeEvent } from "../../../../../../../../utils/types/generals";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../../../../../../../contexts/Global";
import MultiSelectSimple from "../../../../../../../../components/dinamicForm/multiSelectSimple";

interface ReassignModalProps {
  open: boolean;
  onClose: () => void;
  onReassign: (user_asign_id: number) => Promise<void>;
  countFolios: string;
  items: Item[]
}

export const ReassingModal: React.FC<ReassignModalProps> = ({
  open,
  onClose,
  onReassign,
  items,
  countFolios,
}) => {
  const { colors } = useContext(GlobalContext)
  const styles = useReassingModal();
  const [confirmModalOpen, setConfirmModalOpen] = React.useState(false);
  const [selectedProvider, setSelectedProvider] = React.useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const { t } = useTranslation()

  const handleOpenConfirmModal = () => {
    if (selectedProvider) {
      setConfirmModalOpen(true);
      onClose();
    }
  };

  const handleConfirm = async () => {
    if (selectedProvider) {
      setIsSubmitting(true);
      try {
        await onReassign(Number(selectedProvider));
        setConfirmModalOpen(false);
        setSelectedProvider(null);
      } catch (error) {
        console.log(error)
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  const handleProviderChange = (e: onChangeEvent) => {
    setSelectedProvider(e.target.value.value);
  };

  return (
    <>
      <Modal open={open} onClose={onClose}>
        <Box sx={styles.container}>
          <Typography variant="h6" component="h2" textAlign="center" mb={4}>
            {t('reportFolio.detail.general.reassignProvider')}
          </Typography>

          <Stack direction="row" mt={2} mb={2} alignItems="center">
            <Info color="primary" sx={styles.icon} />
            <Typography sx={styles.text} color={colors.color11}>
              {t('reportFolio.detail.general.yourSelectionAffect', { countFolios: countFolios, count: Number(countFolios) })}
            </Typography>
          </Stack>

          <MultiSelectSimple
            isRequired
            errors={null}
            name="user_asign_id"
            label="Proveedor *"
            onChange={handleProviderChange}
            items={items}
            selected={selectedProvider}
          />

          <Stack direction="row" justifyContent="space-between" mt={4}>
            <Button variant="text" color="primary" onClick={onClose}>
              {t('reportFolio.detail.general.cancel')}
            </Button>
            <Button
              variant="contained"
              onClick={handleOpenConfirmModal}
              sx={styles.button}
              disabled={!selectedProvider}
            >
              {t('reportFolio.detail.general.reassing')}
            </Button>
          </Stack>
        </Box>
      </Modal>

      <ConfirmModal
        open={confirmModalOpen}
        onClose={() => !isSubmitting && setConfirmModalOpen(false)}
        onConfirm={handleConfirm}
        title="Confirmación"
        description={`¿Estás seguro que deseas reasignar el usuario asignado? se afectará ${countFolios} folios`}

      />
    </>
  );
};